function checkCartTotal() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartTotal = cart.total_price / 100;
      let itemsToRemove = [];

      cart.items.forEach(item => {
        if (item.properties && item.properties.Tipo === 'Regalo') {
          const upsellValue = item.properties.upsell;
          if (cartTotal >= 100 && upsellValue === '50') {
            itemsToRemove.push(item.key);
          } else if (cartTotal < 100 && cartTotal >= 50 && upsellValue === '100') {
            itemsToRemove.push(item.key);
          } else if (cartTotal < 50) {
            itemsToRemove.push(item.key);
          }
        }
      });

      updateCarouselVisibility(cartTotal);

      if (itemsToRemove.length > 0) {
        itemsToRemove.forEach(itemId => removeLineItem(itemId, cartTotal));
      }
    });
}

function removeLineItem(lineItemId, cartTotal) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: lineItemId,
      quantity: 0
    })
  })
  .then(() => {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  });
}

function updateCarouselVisibility(cartTotal) {
  const upsellDiv = document.getElementById('carrousel-upsell');
  const carousel50 = document.getElementById('featured-collections-carousel-carrousel_over50');
  const carousel100 = document.getElementById('featured-collections-carousel-carrousel_over100');

  if (cartTotal >= 50) {
    upsellDiv.style.display = 'block';
    if (cartTotal >= 100) {
      carousel50.style.display = 'none';
      carousel100.style.display = 'block';
    } else {
      carousel50.style.display = 'block';
      carousel100.style.display = 'none';
    }
  } else {
    upsellDiv.style.display = 'none';
  }
}

function refreshCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartTotal = cart.total_price / 100;
      updateCarouselVisibility(cartTotal);
      checkCartTotal();
    });
}

document.addEventListener('cart:refresh', refreshCart);
addEventListener("load", checkCartTotal);
document.addEventListener('cart:change', checkCartTotal);
document.addEventListener('cart:add', checkCartTotal);
